import React from "react";
import { Button, Text } from "@nextui-org/react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { TbArrowBackUp, TbFileExport } from "react-icons/tb";

const AltEntriesHeader = ({ title = "New Entries", onOpenExport }) => {
  return (
    <motion.div className="header">
      {/* Left Section */}
      <div className="headerLink" style={{ display: "flex", alignItems: "center", zIndex: 2 }}>
        <Link to="/analytics" className="headerLink">
          <TbArrowBackUp className="icoAdjust" />
        </Link>
      </div>

      {/* Center Title */}
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1,
          pointerEvents: "none",
          textAlign: "center",
        }}
      >
        <Text b size="16px" css={{ margin: 0 }}>
          {title}
        </Text>
      </div>

      {/* Right Section */}
      <div className="headerLink headerLinkAddon" style={{ display: "flex", alignItems: "center", zIndex: 2 }}>
        {onOpenExport && (
          <Button
            auto
            size="sm"
            color="error"
            icon={<TbFileExport size={18} />}
            onClick={onOpenExport}
            title="Export Data"
            css={{ px: "10px" }}
          />
        )}
      </div>
    </motion.div>
  );
};

export default AltEntriesHeader;
